import React from "react";
import {FormData,} from "../../@types/SinisterFormTypes"
import { format, parseISO, } from "date-fns";

import { ptBR } from "date-fns/locale";
import { ItemGroup } from "./ItemGroup";
import "./styles.ts";
import { MapCotainer } from "./Map";
import { TableContents } from "./TableContents";

import { KEYS_LOCATION } from "./utils/KeysList";
import { ViaTables } from "./ViaTables";
import { VictimTables } from "./VictimTables";
import { VehicleTables } from "./VehicleTables";
import { AgentsVehiclesTables } from "./AgentsVehiclesTable";
import { useStyles } from "./styles";
import { toDate } from "../../utils/formatDate";
import { PDFHeader } from "./PDFHeader";

interface IncidentImages {
    path: string;
    uuid: string;
    description: string;
  }
interface Props {
  sinistro: FormData;
  sinistroImagens?:IncidentImages[]
}
export const PDFViewWebMode: React.FC<Props> = ({ sinistro, sinistroImagens }) => {
    const styles = useStyles();
    console.log("sinistro",sinistro);
    
    const numbers: number[] = [
    sinistro.data.driverVeiculo.length,
    sinistro.data.driverVitima.length,
  ];
  return (
    <div className={styles.container}>
      <PDFHeader/>
      <div className={styles.mainItemWrapper}>
        <div className={styles.mainItemTitleHeader}><span>1- Detalhes Gerais</span> <span style={{}}>Nº: {sinistro.data.driverIncidenteDetails["Código do Acidente"]}</span></div>
        <div className={styles.mainItemInfoWrapper}>
          <ItemGroup isDate title="OCORRIDO" value={(toDate(sinistro.occurred_from,"dd/mm/yyyy '-' EEEE 'às' HH:mm"))} />
          <ItemGroup isDate title="CRIADO" value={(toDate(sinistro.created,"dd/mm/yyyy '-' EEEE 'às' HH:mm"))} />
        </div>

        <div className={styles.subItemWrapper}>
          <div className={styles.subItemHeader} style={{ justifyContent: "center" }}>
            <b>Localização</b>
          </div>
          <div className={styles.mapView}>
            <div className={styles.map}><MapCotainer geom={sinistro.geom}/></div>
            <div className={styles.mapSubtitles}>
              <ItemGroup isDate title="latitude" value={sinistro.geom.coordinates[1].toString()} />
              <ItemGroup isDate title="longitude" value={sinistro.geom.coordinates[0].toString()} />  
            </div>
          </div>
          <TableContents
            numbers={numbers}
            data={sinistro.data.driverIncidenteDetails}
            keys={KEYS_LOCATION}
          />
        </div>
      </div>

      <div className={styles.mainItemWrapper}>
        <div className={styles.mainItemTitleHeader}>2- Vias</div>
        <div className={styles.mainItemInfoWrapper}></div>

        <ViaTables data={sinistro.data.driverVia} />
      </div>

      <div className={styles.mainItemWrapper}>
        <div className={styles.mainItemTitleHeader}>3- Envolvidos</div>
        <div className={styles.mainItemInfoWrapper}></div>
        <VictimTables data={sinistro.data.driverVitima} />
      </div>

      <div className={styles.mainItemWrapper}>
        <div className={styles.mainItemTitleHeader}>4- Veiculos</div>
        <div className={styles.mainItemInfoWrapper}></div>
        <VehicleTables data={sinistro.data.driverVeiculo} />
      </div>

      <div className={styles.mainItemWrapper}>
        <div className={styles.mainItemTitleHeader}>5- Anexos</div>
        <div className={styles.mainItemInfoWrapper}></div>
      </div>

      <div className={styles.mainItemWrapper}>
        <div className={styles.mainItemTitleHeader}>6- Agentes e Viaturas</div>
        <div className={styles.mainItemInfoWrapper}></div>
        <AgentsVehiclesTables
          observations={sinistro.data.driverIncidenteDetails["Notas Gerais"]}
          agents={sinistro.data.driverAgentsAndVehicles.agents}
          vehicles={sinistro.data.driverAgentsAndVehicles.missionCars}
        />
      </div>
    </div>
  );
};
